import axios from "axios";

const api = axios.create({
  // Para testar com o backend local: REACT_APP_API_URL=http://localhost:3001 yarn start
  baseURL: process.env.REACT_APP_API_URL || "https://mutatio-back.onrender.com",
  headers: {
    "Content-Type": "application/json",
  },
});

// Sessão inválida ou expirada (o backend marca com `authError`): limpa o token
// e volta para o login. Outros 401 (ex.: senha antiga incorreta nas
// configurações) são erros normais e seguem para a tela tratar.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.response.data?.authError) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/") window.location.assign("/");
    }
    return Promise.reject(error);
  },
);

export default api;

// Mensagem de erro enviada pelo backend (quando houver) ou um texto padrão
export const getApiError = (error: unknown, fallback: string): string => {
  const data = (error as { response?: { data?: { error?: unknown } } })
    ?.response?.data;
  return typeof data?.error === "string" && data.error ? data.error : fallback;
};

// Campo do formulário que o backend apontou como errado (ex.: "oldPassword")
export const getApiErrorField = (error: unknown): string | undefined => {
  const data = (error as { response?: { data?: { field?: unknown } } })
    ?.response?.data;
  return typeof data?.field === "string" ? data.field : undefined;
};
